import React, { useCallback } from 'react';
import { Button, Frame, SageClassnames } from '@kajabi/sage-react';
import { trackOptimizelyEvents } from 'common/services/product_analytics';

import { PLAN_INTERVAL_TOGGLE_CLICKED } from '../../helpers/constants';
import { useCheckout } from '../../context';

export const IntervalToggle = () => {
  const {
    isAnnual,
    marketingParams,
    planInfo: {
      annual_price_difference: priceDifference,
      free_plan: freePlan,
      plan: { annual_downgrade_id: monthlyId, annual_upgrade_id: annualId, id },
      show_time_interval_slider: showInterval,
    },
    successfulExpressCheckout,
    isTwoStepsSignupFirstStep,
  } = useCheckout();

  const buildButtonProps = useCallback(
    (canBuild) =>
      canBuild
        ? {
            onClick: handleTracking,
            href: `${
              window.location.origin +
              window.location.pathname.replace(id, isAnnual ? monthlyId : annualId)
            }?${new URLSearchParams(marketingParams).toString()}`,
          }
        : {},
    [id, isAnnual, monthlyId, annualId, marketingParams],
  );

  const handleTracking = () => {
    trackOptimizelyEvents(PLAN_INTERVAL_TOGGLE_CLICKED);
  };

  const renderIntervalToggle = () => {
    if (isTwoStepsSignupFirstStep() || successfulExpressCheckout || freePlan) {
      return null;
    }

    return (
      <Frame align={Frame.ALIGNMENTS.TOP_CENTER} gap={Frame.GAPS.SM}>
        {showInterval && (
          <Frame
            align={Frame.ALIGNMENTS.TOP_CENTER}
            className="interval-toggle"
            direction={Frame.DIRECTIONS.HORIZONTAL}
            gap={Frame.GAPS.NONE}
            style={{ width: 178 }}
          >
            <Button
              color={Button.COLORS[isAnnual ? 'PRIMARY' : 'SECONDARY']}
              fullWidth
              {...buildButtonProps(!isAnnual)}
            >
              Annual
            </Button>
            <Button
              color={Button.COLORS[isAnnual ? 'SECONDARY' : 'PRIMARY']}
              fullWidth
              {...buildButtonProps(isAnnual)}
            >
              Monthly
            </Button>
          </Frame>
        )}
        {priceDifference && (
          <p className={SageClassnames.TYPE_COLORS.SAGE_300} style={{ textAlign: 'center' }}>
            You&apos;re saving {priceDifference} by paying annually!
          </p>
        )}
      </Frame>
    );
  };

  return renderIntervalToggle();
};
